import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appLoadNumberInput]',
  standalone: false,
})
export class LoadNumberInputDirective {
  private readonly allowedCharsPattern = /[^a-zA-Z0-9-]/g;

  constructor(private el: ElementRef<HTMLInputElement>, private control: NgControl) {}

  @HostListener('input') onInputEvent(): void {
    const input = this.el.nativeElement;
    const selectionStart = input.selectionStart;
    const originalValue = input.value;
    const cleanedValue = originalValue.replace(this.allowedCharsPattern, '');

    if (originalValue === cleanedValue) {
      return;
    }

    const cursorPosition = originalValue.slice(0, selectionStart).replace(this.allowedCharsPattern, '').length;
    this.control.control.setValue(cleanedValue, { emitEvent: false });
    input.setSelectionRange(cursorPosition, cursorPosition);
  }
}
